// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DiqpQ","newExpiryDate":"styles_newExpiryDate__1aeGg","footer":"styles_footer__15Siv"};